import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
// import { apiurl } from '../../../../path';
import { Link } from "react-router-dom";
// import "./rejectpanel.css";
import {
  Back32,
  Cancel32,
  ProposalCreation32,
  submit,
} from "../../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../../path";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import GooglePagination from "../../../styles/GooglePagination";

const ViewOldBills = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetBudgetHeadInfo, TechnicalOutwards, Usermenu } = context;

  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [proposallist, setProposalList] = useState([]);

  const [approvedYear, setApprovedYear] = useState("");

  console.log("technicalInwards", technicalInwards);

  const [UserRole, setUserRole] = useState("");
  const [AllDistrict, setAllDistrict] = useState([]);
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [SelectedDistrict, setSelectedDistrict] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  // const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] = useState("");
   const [SelectedTaluka, setSelectedTaluka] = useState([]);
const [openTaluka, setOpenTaluka] = useState(false);
  const [statusofData, setstatusofData] = useState("Sent to Bank");
  const [statusofData1, setstatusofData1] = useState("");
  const [RoleID, setroleID] = useState(null);
  const [typeofData, settypeofData] = useState("District");
  const [openDistrict, setOpenDistrict] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAll, setShowAll] = useState(false);
  const billsPerPage = showAll ? filteredBills.length || 1 : 10;
  const [searchTerm, setSearchTerm] = useState("");
  const budgetEstimation = proposallist;

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
    const [selectedHeadCode, setSelectedHeadCode] = useState("");
  const [exportingPDF, setExportingPDF] = useState(false);
  const [loading, setloading] = useState(false);
  const displayedGRS = exportingPDF ? filteredBills : currentBills;

  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };
  const commonWidth = `${100 / 7}%`; // whatever the current width of Department Auditor looks like

  const headerStyle1 = {
    width: commonWidth,
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

  const cellStyle = {
    width: commonWidth, // 100% / 7 columns
    padding: "8px",
    textAlign: "center",
    //   whiteSpace: 'nowrap'
  };

  const getTechnicalInwardsList = async () => {
    let data = await GetBudgetHeadInfo("All", "GetDemandGenerationList");
    let data1 = await TechnicalOutwards("OldBill");
    const { status, message, Tabletype } = data1;

    if (status) {
      setTechnicalInwards(message);
      setProposalList(message);
      // setFilteredBills(message);
      setUserRole(Tabletype);
    } else {
      alert(message);
    }
  };
  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setroleID(roleID);
      console.log("sffdsf", data?.Data);
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };
  useEffect(() => {
    getTechnicalInwardsList();
    getmenu();
  }, []);

 const allDistricts = [
  ...new Set(
    AllDistrict
      ?.map((d) =>
        d?.District_Marathi?.split("-")[0]?.trim()
      )
      .filter(Boolean)
  ),
];
  const isAllSelected = SelectedDistrict.length === allDistricts.length;

  const toggleAllDistricts = () => {
    setSelectedDistrict(isAllSelected ? [] : allDistricts);
  };
  const handleDistrictToggle = (district) => {
    setSelectedDistrict((prev) =>
      prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district],
    );
  };

  const filteredTalukas = [
  ...new Set(
    technicalInwards
      ?.filter((item) => {
        // No district selected (taluka/district login, or State user hasn't picked yet)
        if (!SelectedDistrict || SelectedDistrict.length === 0) return true;

        const itemDistrict = item?.District || "";
        return SelectedDistrict.some(
          (district) =>
            itemDistrict === district ||
            itemDistrict.startsWith(`${district}-`)
        );
      })
      .map((item) => item?.Taluka)
      .filter(Boolean)
  ),
].sort();

  const allTalukas = [
  ...new Set(TalukasofDistrict?.map((t) => t.Taluka_Marathi)),
];
 
const isAllTalukasSelected =
  allTalukas.length > 0 && SelectedTaluka.length === allTalukas.length;
 
const toggleAllTalukas = () => {
  setSelectedTaluka(
    isAllTalukasSelected ? [] : allTalukas
  );
};
 
const handleTalukaToggle = (taluka) => {
  setSelectedTaluka((prev) =>
    prev.includes(taluka)
      ? prev.filter((t) => t !== taluka)
      : [...prev, taluka]
  );
};

  const convertToComparableDate = (dateStr) => {
    if (!dateStr) return null;

    // DD-MM-YYYY
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
      const [dd, mm, yyyy] = dateStr.split("-");
      return `${yyyy}-${mm}-${dd}`;
    }

    // YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return dateStr;
    }

    // ISO Date
    if (dateStr.includes("T")) {
      return dateStr.split("T")[0];
    }

    return null;
  };

  useEffect(() => {
    let filtered = [...technicalInwards];
    console.log("All data ---> ", technicalInwards);
    if (typeofData === "District" && RoleID === 29) {
      filtered = filtered.filter(
        (item) =>
          item.BudgetID ===
          "3054-2419(Roads and bridge repair maintenance program)",
      );
      console.log("filtered Date 3054", filtered);
    } else if (typeofData === "State" && RoleID === 29) {
      filtered = filtered.filter(
        (item) => item.BudgetID === "2515-1238(MLA Representative)",
      );
    }
    // 🔹 Filter by District (MULTI-SELECT)
    if (SelectedDistrict?.length > 0) {
      filtered = filtered.filter((item) => {
        const itemDistrict = item?.District || "";

        return SelectedDistrict.some(
          (district) =>
            itemDistrict === district ||
            itemDistrict.startsWith(`${district}-`)
        );
      });
    }
    // 🔹 Filter by Taluka (MULTI-SELECT)
    if (SelectedTaluka?.length > 0) {
      filtered = filtered.filter((item) =>
        SelectedTaluka.includes(item.Taluka),
      );
    }

    // 🔹 Filter by Approval / Status
    if (statusofData1) {
      if (statusofData1 === "false") {
        filtered = filtered.filter(
          (item) =>
            item.Approvance1 === "false" ||
            item.Approvance2 === "false" ||
            item.Approvance3 === "false" ||
            item.Approvance4 === "false" ||
            item.Approvance5 === "false" ||
            item.Approvance6 === "false" ||
            item.Approvance9 === "false" ||
            item.Approvance8 === "false" ||
            item.Approvance9 === "false",
        );
      } else if (statusofData1 === "Approved") {
        // ✅ Added block
        filtered = filtered.filter(
          (item) =>
            item.Approvance1 === "true" &&
            item.Approvance2 === "true" &&
            item.Approvance3 === "true" &&
            item.Approvance4 === "true" &&
            item.Approvance5 === "true" &&
            item.Approvance6 === "true" &&
            item.Approvance9 === "true" &&
            item.Approvance8 === "true" &&
            item.Approvance9 === "true",
        );
      } else if (statusofData1 === "Rejected") {
        filtered = filtered.filter((item) => item.Status === "Rejected");
      }
    }

    console.log("Filter data ---> ", filtered);

    // Approved Year Filter
    if (approvedYear) {
      filtered = filtered.filter(
        (item) => String(item.AAYear) === String(approvedYear),
      );
    }

    if (fromDate || toDate) {
      filtered = filtered.filter((item) => {
        const billDate = convertToComparableDate(item.BillReceivedDate);

        if (!billDate) return false;

        if (fromDate && toDate) {
          return billDate >= fromDate && billDate <= toDate;
        }

        if (fromDate) {
          return billDate >= fromDate;
        }

        if (toDate) {
          return billDate <= toDate;
        }

        return true;
      });
    }

    // 🔹 Search Filter
    // if (searchTerm.trim()) {
    //   const lower = searchTerm.toLowerCase();
    //   filtered = filtered.filter((bill) =>
    //     Object.values(bill).some((val) =>
    //       String(val ?? "")
    //         .toLowerCase()
    //         .includes(lower),
    //     ),
    //   );
    // }
if (searchTerm.trim() || selectedHeadCode) {
  const lowerSearchTerm = searchTerm.trim().toLowerCase();

  filtered = filtered.filter((item) => {

    // Search in all fields
    const matchesSearch =
      !lowerSearchTerm ||
      Object.values(item).some((value) =>
        String(value ?? "")
          .toLowerCase()
          .includes(lowerSearchTerm)
      );

    // HeadCode filter
    const matchesHeadCode =
      !selectedHeadCode ||
      String(item.HeadCode ?? "").startsWith(selectedHeadCode);

    return matchesSearch && matchesHeadCode;
  });
}
    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [
    statusofData1,
    searchTerm,
    technicalInwards,
    SelectedDistrict,
    typeofData,
    fromDate,
    toDate,
    approvedYear,
    selectedHeadCode,
    SelectedTaluka,
  ]);

  const selectedBillDetails = (BillID) => {
    const result = budgetEstimation
      .filter((item) => item.DemandGenerationID == BillID)
      .map((item) => ({
        "Demand ID": item.DemandGenerationID,
        "Bill Number": item.RABillNumber,
        "Proposal ID": item.ProjectID,
        "Head ID": item.BudgetID,
        District: item.District,
        "Contractor Name": item.ContractorName,
        "Work Order UID": item.WorkOrderUID,
        "Upload Demand Copy": item.UploadBillCopy,
        Remark: item.Remark,
        "Bill Amount": item.BillAmount,
        "Net Payable Amount": item.NetPayableAmount,
        "Deduction Amount": item.DeductionAmount,
        Date: new Date(item.Date).toLocaleString(),
      }));

    console.log("------------------", result);
    setSelectedProposal(result[0]);
  };

  const FetchGramPanachayatInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "AllDistrict");
      // console.log("Data i get:: ", res);
      setAllDistrict(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchGramPanachayatInfo();
  }, []);

   useEffect(() => {
    setSelectedTaluka([]);
  }, [SelectedDistrict]);

  const totalBillamt = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.BillAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const totalpayableamt = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.NetPayableAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const totaldeductionamt = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.DeductionAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  const exportTableByClassToExcel = async (
    bills,
    filename = "Bills_Outward.xlsx",
  ) => {
    if (!bills || bills.length === 0) {
      alert("No data available");
      return;
    }

    setloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      const getStatus = (val) =>
  val === "true" ? "✓" : val === "false" ? "✕" : "-";

const excelData = bills.map((proposal, index) => ({
  "Sr.No.": index + 1,
  "Demand ID": proposal.DemandGenerationID || "-",
  "Administrative Approved Year": proposal.AAYear || "-",
  "Work Name": proposal.WorkName || "-",
  District: proposal.District || "-",
  Taluka: proposal.Taluka || "-",
  "Work Approved GR": proposal.GROrderNo || "-",
  "Technical Sanction Number": proposal.AANo || "-",
  "Beneficiary Name": proposal.BeneficiaryName || "-",
  "Bill Amount": proposal.BillAmount || 0,
  "Net Payable Amount": proposal.NetPayableAmount || 0,
  "Deduction Amount": proposal.DeductionAmount || 0,
  "Bill Received Date": proposal.BillReceivedDate || "-",
  "Uploaded Date": proposal.UploadedOn
    ? new Date(proposal.UploadedOn).toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
    : "-",
  "Approved By (RDD)": getStatus(proposal.Approvance9),
}));

      /* 🔢 TOTAL ROW */
      const totalRow = {
  "Sr.No.": `Total Records : ${bills.length}`,
  "Demand ID": "",
  "Administrative Approved Year": "",
  "Work Name": "",
  District: "",
  Taluka: "",
  "Work Approved GR": "",
  "Technical Sanction Number": "",
  "Beneficiary Name": "Total",
  "Bill Amount": bills.reduce(
    (sum, b) => sum + Number(b.BillAmount || 0),
    0
  ),
  "Net Payable Amount": bills.reduce(
    (sum, b) => sum + Number(b.NetPayableAmount || 0),
    0
  ),
  "Deduction Amount": bills.reduce(
    (sum, b) => sum + Number(b.DeductionAmount || 0),
    0
  ),
  "Bill Received Date": "",
  "Uploaded Date": "",
  "Approved By (RDD)": "",
};

excelData.push(totalRow);

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      /* Column width */
      worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({
        wch: 22,
      }));

      /* Freeze header */
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

      /* Filter */
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: {
            r: excelData.length,
            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Bills");
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setloading(false); // ✅ ALWAYS stop loader
    }
  };
const downloadTableOnlyAsPDF = async (
  tableClass,
  filename,
  title,
  chunkSize = 500, // 300–500 recommended
) => {
  setloading(true);
  setExportingPDF(true);

  // Allow loader to render and React to re-render all rows
  await new Promise((resolve) => setTimeout(resolve, 600));

  const originalTable = document.querySelector(`.${tableClass}`);
  if (!originalTable) {
    setExportingPDF(false);
    setloading(false);
    return;
  }

  // "₹ 1,23,456.50" -> 123456.5
  const parseAmount = (text) => {
    const n = parseFloat((text || "").replace(/[^0-9.-]/g, ""));
    return isNaN(n) ? 0 : n;
  };

  const formatAmount = (n) =>
    "₹ " +
    n.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  // Builds one total row. Every amount column gets its own total,
  // placed exactly under that column.
  const buildTotalRow = (label, totals, amountCols, headerColCount) => {
    const tr = document.createElement("tr");
    tr.style.fontWeight = "bold";
    tr.style.backgroundColor = "#f0f0f0";

    const firstAmountCol = amountCols[0];

    // Label cell spans everything before the first amount column
    if (firstAmountCol > 0) {
      const labelTd = document.createElement("td");
      labelTd.textContent = label;
      labelTd.colSpan = firstAmountCol;
      labelTd.style.textAlign = "right";
      labelTd.style.padding = "8px";
      tr.appendChild(labelTd);
    }

    // One cell per remaining column
    for (let col = firstAmountCol; col < headerColCount; col++) {
      const td = document.createElement("td");
      td.style.padding = "8px";
      td.style.whiteSpace = "nowrap";

      const amountIdx = amountCols.indexOf(col);
      if (amountIdx !== -1) {
        td.textContent = formatAmount(totals[amountIdx]);
      }
      // If label has no room before the first amount column, put it here
      if (firstAmountCol === 0 && col === 0 && amountIdx === -1) {
        td.textContent = label;
      }
      tr.appendChild(td);
    }

    return tr;
  };

  try {
    const headerCells = Array.from(
      originalTable.querySelectorAll("thead tr:first-child th"),
    );
    const headerColCount = headerCells.length;

    // Sr.No column
    let srColIndex = headerCells.findIndex((th) =>
      th.textContent.trim().toLowerCase().startsWith("sr"),
    );
    if (srColIndex === -1) srColIndex = 0;

    // ALL amount columns (Bill Amount, Net Payable Amount, Deduction Amount...)
    const amountCols = headerCells
      .map((th, i) =>
        th.textContent.trim().toLowerCase().includes("amount") ? i : -1,
      )
      .filter((i) => i !== -1);

    const hasAmountCols = amountCols.length > 0;

    // Only real data rows (skip "No data" / existing total rows with colSpan)
    const originalRows = Array.from(
      originalTable.querySelectorAll("tbody tr"),
    ).filter((row) => {
      const cells = row.querySelectorAll("td");
      if (cells.length === 0) return false;
      return !Array.from(cells).some((c) => c.colSpan && c.colSpan > 1);
    });

    const totalRows = originalRows.length;
    if (!totalRows) return;

    // Gross totals of ALL rows, one value per amount column
    const grossTotals = amountCols.map((colIdx) =>
      originalRows.reduce((sum, row) => {
        const cell = row.querySelectorAll("td")[colIdx];
        return sum + parseAmount(cell?.textContent);
      }, 0),
    );

    for (let start = 0; start < totalRows; start += chunkSize) {
      const end = Math.min(start + chunkSize, totalRows);
      const isLastChunk = end === totalRows;

      let tableClone;

      try {
        tableClone = originalTable.cloneNode(true);

        const cloneTbody = tableClone.querySelector("tbody");
        cloneTbody.innerHTML = "";

        // Add only the rows for the current chunk and sum each amount column
        const chunkTotals = amountCols.map(() => 0);

        for (let i = start; i < end; i++) {
          const rowClone = originalRows[i].cloneNode(true);
          cloneTbody.appendChild(rowClone);

          const cells = rowClone.querySelectorAll("td");
          amountCols.forEach((colIdx, k) => {
            chunkTotals[k] += parseAmount(cells[colIdx]?.textContent);
          });
        }

        // Always renumber Sr.No. from 1 (continues across chunks)
        cloneTbody.querySelectorAll("tr").forEach((row, index) => {
          const cells = row.querySelectorAll("td");
          if (cells[srColIndex]) {
            cells[srColIndex].textContent = start + index + 1;
          }
        });

        // ===== TOTAL ROWS AT THE END =====
        if (hasAmountCols) {
          cloneTbody.appendChild(
            buildTotalRow("Total", chunkTotals, amountCols, headerColCount),
          );

          // Gross total only on the last file, and only if there are multiple files
          if (isLastChunk && totalRows > chunkSize) {
            cloneTbody.appendChild(
              buildTotalRow(
                "Gross Total",
                grossTotals,
                amountCols,
                headerColCount,
              ),
            );
          }
        }

        // Hide cloned table from view
        tableClone.style.position = "absolute";
        tableClone.style.left = "-9999px";
        tableClone.style.top = "0";
        document.body.appendChild(tableClone);

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const topMargin = 25;
        const sideMargin = 10;
        const bottomMargin = 15;

        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
          align: "center",
        });

        const canvas = await html2canvas(tableClone, {
          scale: 1,
          useCORS: true,
          backgroundColor: "#ffffff",
        });

        const imgWidth = pageWidth - sideMargin * 2;
        const pxToMm = imgWidth / canvas.width;

        const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
        const usablePageHeightPx = usablePageHeightMm / pxToMm;

        let renderedHeight = 0;
        let pageNumber = 0;

        while (renderedHeight < canvas.height) {
          const sliceHeight = Math.min(
            usablePageHeightPx,
            canvas.height - renderedHeight,
          );

          const pageCanvas = document.createElement("canvas");
          const context = pageCanvas.getContext("2d");

          pageCanvas.width = canvas.width;
          pageCanvas.height = sliceHeight;

          context.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            sliceHeight,
            0,
            0,
            canvas.width,
            sliceHeight,
          );

          const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

          if (pageNumber > 0) pdf.addPage();

          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight * pxToMm,
          );

          renderedHeight += sliceHeight;
          pageNumber++;
        }

        pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);
      } finally {
        if (tableClone && tableClone.parentNode) {
          tableClone.parentNode.removeChild(tableClone);
        }
      }

      // Small delay prevents UI freezing
      await new Promise((resolve) => setTimeout(resolve, 300));
    }
  } catch (error) {
    console.error("PDF Export Error:", error);
  } finally {
    setExportingPDF(false);
    setloading(false);
  }
};
  // const downloadTableOnlyAsPDF = async (
  //   tableClass,
  //   filename,
  //   title,
  //   chunkSize = 500, // 🔥 300–500 recommended
  // ) => {
  //   const originalTable = document.querySelector(`.${tableClass}`);
  //   if (!originalTable) {
  //     setExportingPDF(false);
  //     return;
  //   }

  //   setloading(true);
  //   setExportingPDF(true);

  //   // Allow loader to render first
  //   await new Promise((resolve) => setTimeout(resolve, 600));

  //   try {
  //     const originalRows = originalTable.querySelectorAll("tbody tr");
  //     const totalRows = originalRows.length;

  //     if (!totalRows) {
  //       setloading(false);
  //       setExportingPDF(false);
  //       return;
  //     }

  //     for (let start = 0; start < totalRows; start += chunkSize) {
  //       const end = Math.min(start + chunkSize, totalRows);

  //       // 🔥 Clone table cleanly
  //       const tableClone = originalTable.cloneNode(true);
  //       const rows = tableClone.querySelectorAll("tbody tr");

  //       // Remove rows outside current chunk
  //       rows.forEach((row, index) => {
  //         if (index < start || index >= end) {
  //           row.remove();
  //         }
  //       });

  //       // Hide cloned table from view
  //       tableClone.style.position = "absolute";
  //       tableClone.style.left = "-9999px";
  //       tableClone.style.top = "0";
  //       document.body.appendChild(tableClone);

  //       const pdf = new jsPDF("p", "mm", "a4");
  //       const pageWidth = pdf.internal.pageSize.getWidth();
  //       const pageHeight = pdf.internal.pageSize.getHeight();

  //       const topMargin = 25;
  //       const sideMargin = 10;
  //       const bottomMargin = 15;

  //       pdf.setFontSize(16);
  //       pdf.setFont("helvetica", "bold");
  //       pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
  //         align: "center",
  //       });

  //       const canvas = await html2canvas(tableClone, {
  //         scale: 1,
  //         useCORS: true,
  //         backgroundColor: "#2C78DB",
  //       });

  //       const imgWidth = pageWidth - sideMargin * 2;
  //       const pxToMm = imgWidth / canvas.width;

  //       const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
  //       const usablePageHeightPx = usablePageHeightMm / pxToMm;

  //       let renderedHeight = 0;
  //       let pageNumber = 0;

  //       while (renderedHeight < canvas.height) {
  //         const sliceHeight = Math.min(
  //           usablePageHeightPx,
  //           canvas.height - renderedHeight,
  //         );

  //         const pageCanvas = document.createElement("canvas");
  //         const context = pageCanvas.getContext("2d");

  //         pageCanvas.width = canvas.width;
  //         pageCanvas.height = sliceHeight;

  //         context.drawImage(
  //           canvas,
  //           0,
  //           renderedHeight,
  //           canvas.width,
  //           sliceHeight,
  //           0,
  //           0,
  //           canvas.width,
  //           sliceHeight,
  //         );

  //         const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

  //         if (pageNumber > 0) pdf.addPage();

  //         pdf.addImage(
  //           imgData,
  //           "JPEG",
  //           sideMargin,
  //           topMargin,
  //           imgWidth,
  //           sliceHeight * pxToMm,
  //         );

  //         renderedHeight += sliceHeight;
  //         pageNumber++;
  //       }

  //       pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

  //       document.body.removeChild(tableClone);

  //       // Small delay prevents UI freezing
  //       await new Promise((resolve) => setTimeout(resolve, 300));
  //     }
  //   } catch (error) {
  //     console.error("PDF Export Error:", error);
  //   } finally {
  //     setExportingPDF(false);
  //     setloading(false);
  //   }
  // };

   const pagetotalBillamt = currentBills?.reduce((sum, item) => {
    const amount = Number(item?.BillAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const pagetotalpayableamt = currentBills?.reduce((sum, item) => {
    const amount = Number(item?.NetPayableAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const pagetotaldeductionamt = currentBills?.reduce((sum, item) => {
    const amount = Number(item?.DeductionAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  return (
    <>
      <div
        className="col-12"
        style={{
          backgroundColor: "#EFF3F8",
          height: "89vh",
          overflowX: "hidden",
          overflowY: "scroll",
          position: "relative",
        }}
      >
        <div
          style={{
            filter: loading ? "blur(4px)" : "none",
            pointerEvents: loading ? "none" : "auto",
            transition: "0.2s ease",
          }}
        >
          <div className="col-11 m-auto">
            <div className="col-12 ">
              <div
                className="col-12 px-4 mb-4 mt-3"
                style={{
                  filter: loading ? "blur(4px)" : "none",
                  pointerEvents: loading ? "none" : "auto",
                  transition: "0.2s ease",
                }}
              >
                {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                  <h5 className="fw-bold d-flex align-items-center m-0">
                    <img
                      src="/GR-Approval64.png"
                      alt="Technical Approval"
                      style={{
                        width: "24px",
                        height: "24px",
                        marginRight: "6px",
                      }}
                    />
                    {t("Old Pending Bill Outward")}
                  </h5>

                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-success"
                      onClick={() =>
                        exportTableByClassToExcel(
                          filteredBills,
                          "Bills_Outward.xlsx",
                        )
                      }
                    >
                      {t("Download Excel")}
                    </button>

                    <button
                      className="btn btn-danger"
                      onClick={() =>
                        downloadTableOnlyAsPDF(
                          "BillsOutwardTable",
                          "Bills_Outward.pdf",
                          "Bills Outward Report",
                        )
                      }
                    >
                      {t("Download PDF")}
                    </button>
                  </div>
                </div>

                {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  {UserRole === "State" && RoleID == 29 && (
                    <select
                      value={typeofData}
                      onChange={(e) => settypeofData(e.target.value)}
                      style={{
                        width: "150px",
                        height: "40px",
                        padding: "0 12px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        fontSize: "13px",
                        boxSizing: "border-box",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <option value="" disabled selected>
                        Choose Data
                      </option>
                      <option value="District">
                        {t("3054-2419(Roads and bridge repair maintenance program)")}
                      </option>
                      <option value="State">{t("2515-1238(MLA Representative)")}</option>
                    </select>
                  )}

                  {/* Status */}
                  <select
                    value={statusofData1}
                    onChange={(e) => setstatusofData1(e.target.value)}
                    style={{
                      width: "150px",
                      height: "40px",
                      padding: "0 12px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      fontSize: "13px",
                      boxSizing: "border-box",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <option value="">{t("All")}</option>
                    <option value="Approved">{t("Approved")}</option>
                    <option value="false">{t("Pending")}</option>
                    {/* <option value="Rejected">{t("Rejected")}</option> */}
                  </select>

                  {/* District */}
                  {UserRole === "State" && (
                    <div style={{ position: "relative", width: "160px" }}>
                      <div
                        onClick={() => setOpenDistrict(!openDistrict)}
                        style={{
                          height: "40px",
                          padding: "0 12px",
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          background: "#fff",
                          cursor: "pointer",
                          fontSize: "13px",
                          boxSizing: "border-box",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {SelectedDistrict.length > 0
                          ? SelectedDistrict.join(", ")
                          : "Select District"}
                      </div>

                      {openDistrict && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            width: "100%",
                            background: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            marginTop: "4px",
                            zIndex: 1000,
                            boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                          }}
                        >
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "6px 8px",
                              borderBottom: "1px solid #eee",
                              cursor: "pointer",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={isAllSelected}
                              onChange={toggleAllDistricts}
                              style={{ marginRight: "6px" }}
                            />
                            {t("All Districts")}
                          </label>
                          <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                            {allDistricts.map((district, index) => (
                                <label
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "6px 8px",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={SelectedDistrict.includes(district)}
                                    onChange={() => handleDistrictToggle(district)}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ marginRight: "6px" }}
                                  />
                                  {district}
                                </label>
                              )
                            )}
                          </div>
                          <div
                            style={{
                              padding: "6px",
                              textAlign: "right",
                              borderTop: "1px solid #eee",
                            }}
                          >
                            <button
                              onClick={() => setOpenDistrict(false)}
                              style={{
                                padding: "4px 10px",
                                fontSize: "12px",
                                border: "none",
                                borderRadius: "6px",
                                background: "#0d6efd",
                                color: "#fff",
                                cursor: "pointer",
                              }}
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Taluka */}
                  <div style={{ position: "relative", width: "160px" }}>
                    <div
                      onClick={() => setOpenTaluka(!openTaluka)}
                      style={{
                        height: "40px",
                        padding: "0 12px",
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        background: "#fff",
                        cursor: "pointer",
                        fontSize: "13px",
                        boxSizing: "border-box",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {SelectedTaluka.length > 0
                        ? SelectedTaluka.join(", ")
                        : "Select Taluka"}
                    </div>

                    {openTaluka && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          width: "100%",
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          marginTop: "4px",
                          zIndex: 1000,
                          boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                        }}
                      >
                        <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                          {filteredTalukas.map((taluka, index) => (
                            <label
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 8px",
                                cursor: "pointer",
                                fontSize: "13px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={SelectedTaluka.includes(taluka)}
                                onChange={() =>
                                  setSelectedTaluka((prev) =>
                                    prev.includes(taluka)
                                      ? prev.filter((t) => t !== taluka)
                                      : [...prev, taluka]
                                  )
                                }
                                style={{ marginRight: "6px" }}
                              />
                              {taluka}
                            </label>
                          ))}
                        </div>
                        <div
                          style={{
                            padding: "6px",
                            textAlign: "right",
                            borderTop: "1px solid #eee",
                          }}
                        >
                          <button
                            onClick={() => setOpenTaluka(false)}
                            style={{
                              padding: "4px 10px",
                              fontSize: "12px",
                              border: "none",
                              borderRadius: "6px",
                              background: "#0d6efd",
                              color: "#fff",
                              cursor: "pointer",
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* From date */}
                  <div
                    style={{
                      height: "40px",
                      padding: "0 10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      width: "170px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      background: "#fff",
                      boxSizing: "border-box",
                    }}
                  >
                    <span style={{ fontSize: "13px", fontWeight: 500, whiteSpace: "nowrap" }}>
                      {t("From")}
                    </span>
                    <input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      style={{
                        border: "none",
                        outline: "none",
                        width: "100%",
                        fontSize: "13px",
                        background: "transparent",
                      }}
                    />
                  </div>

                  {/* To date */}
                  <div
                    style={{
                      height: "40px",
                      padding: "0 10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      width: "170px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      background: "#fff",
                      boxSizing: "border-box",
                    }}
                  >
                    <span style={{ fontSize: "13px", fontWeight: 500, whiteSpace: "nowrap" }}>
                      {t("To")}
                    </span>
                    <input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      style={{
                        border: "none",
                        outline: "none",
                        width: "100%",
                        fontSize: "13px",
                        background: "transparent",
                      }}
                    />
                  </div>

                  {/* Year Filter */}
                  <select
                    value={approvedYear}
                    onChange={(e) => setApprovedYear(e.target.value)}
                    style={{
                      width: "190px",
                      height: "40px",
                      padding: "0 12px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      fontSize: "13px",
                      boxSizing: "border-box",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <option value="">{t("Select Administrative Approved Year")}</option>
                    {[
                      ...new Set(
                        technicalInwards?.map((item) => item.AAYear).filter(Boolean)
                      ),
                    ]
                      .sort()
                      .map((year, index) => (
                        <option key={index} value={year}>
                          {year}
                        </option>
                      ))}
                  </select>

                  {/* Search */}
                  <div style={{ position: "relative", width: "220px" }}>
                    <img
                      src="/Search32.png"
                      alt="Search"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        width: "16px",
                        opacity: 0.6,
                      }}
                    />
                    <input
                      type="text"
                      placeholder={t("Search Here")}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        width: "100%",
                        height: "40px",
                        padding: "0 12px 0 34px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f1f6fc",
                        fontSize: "13px",
                        boxSizing: "border-box",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    />
                  </div>
                </div>
                
                {/* old code */}
                {/* <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "nowrap",
                  }}
                >
                  <select
                    value={statusofData1}
                    onChange={(e) => setstatusofData1(e.target.value)}
                    style={{
                      width: "150px",
                      padding: "8px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      fontSize: "18px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <option value="">{t("All")}</option>
                    <option value="Approved">{t("Approved")}</option>
                    <option value="false">{t("Pending")}</option>
                    <option value="Rejected">{t("Rejected")}</option>
                  </select>
 <select
                                 value={selectedHeadCode}
                                 onChange={(e) => setSelectedHeadCode(e.target.value)}
                                 style={{
                                     width: "120px",
                                     padding: "8px 10px",
                                     border: "1px solid #ccc",
                                     borderRadius: "8px",
                                     fontSize: "14px",
                                     outline: "none"
                                 }}
                             >
                                 <option value="">{t("All Head Codes")}</option>
                                 <option value="3054">
                                     3054-2419 (Roads and Bridge Repair Maintenance Program)
                                 </option>
                                 <option value="2515">
                                     2515-1238 (MLA Representative)
                                 </option>
                             </select>
                  {UserRole === "State" && (
                    <div style={{ position: "relative", width: "160px" }}>
                      <div
                        onClick={() => setOpenDistrict(!openDistrict)}
                        style={{
                          padding: "8px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          background: "#fff",
                          cursor: "pointer",
                          fontSize: "13px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {SelectedDistrict.length > 0
                          ? SelectedDistrict.join(", ")
                          : "Select District"}
                      </div>

                      {openDistrict && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            width: "100%",
                            background: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            marginTop: "4px",
                            zIndex: 1000,
                          }}
                        >
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "6px 8px",
                              borderBottom: "1px solid #eee",
                              cursor: "pointer",
                              fontSize: "18px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={isAllSelected}
                              onChange={toggleAllDistricts}
                              style={{ marginRight: "6px" }}
                            />
                            {t("All Districts")}
                          </label>
                          <div
                            style={{ maxHeight: "150px", overflowY: "auto" }}
                          >
                            {[
                              ...new Set(
                                AllDistrict?.map((d) => d.District_Marathi),
                              ),
                            ].map((district, index) => (
                              <label
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "6px 8px",
                                  cursor: "pointer",
                                  fontSize: "18px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={SelectedDistrict.includes(district)}
                                  onChange={() =>
                                    handleDistrictToggle(district)
                                  }
                                  onClick={(e) => e.stopPropagation()}
                                  style={{ marginRight: "6px" }}
                                />
                                {district}
                              </label>
                            ))}
                          </div>

                          <div
                            style={{
                              padding: "6px",
                              textAlign: "right",
                              borderTop: "1px solid #eee",
                            }}
                          >
                            <button
                              onClick={() => setOpenDistrict(false)}
                              style={{
                                padding: "4px 10px",
                                fontSize: "18px",
                                border: "none",
                                borderRadius: "6px",
                                background: "#0d6efd",
                                color: "#fff",
                                cursor: "pointer",
                              }}
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  <select
                    value={approvedYear}
                    onChange={(e) => setApprovedYear(e.target.value)}
                    style={{
                      width: "150px",
                      padding: "8px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      fontSize: "15px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <option value="">{t("Select Administrative Approved Year")}</option>

                    {[
                      ...new Set(
                        technicalInwards
                          ?.map((item) => item.AAYear)
                          .filter(Boolean),
                      ),
                    ]
                      .sort()
                      .map((year, index) => (
                        <option key={index} value={year}>
                          {year}
                        </option>
                      ))}
                  </select>

                  <div style={{ display: "flex", gap: "8px" }}>

                    <div className="d-flex gap-2">
                      <div className="input-group" style={{ width: "170px" }}>
                        <span className="input-group-text">From</span>
                        <input
                          type="date"
                          className="form-control"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      </div>

                      <div className="input-group" style={{ width: "170px" }}>
                        <span className="input-group-text">To</span>
                        <input
                          type="date"
                          className="form-control"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ position: "relative", width: "220px" }}>
                    <img
                      src="/Search32.png"
                      alt="Search"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        width: "16px",
                        opacity: 0.6,
                      }}
                    />
                    <input
                      type="text"
                      placeholder={t("Search Here")}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px 12px 8px 32px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f1f6fc",
                        fontSize: "18px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    />
                  </div>
                </div> */}
              </div>

              <div className="col-12 pb-5">
                <div
                  className="m-auto mb-3"
                  style={{
                    backgroundColor: "white",
                    padding: "40px 40px",
                    boxShadow: "0px 0px 5px 1px #E4E8EC",
                    borderRadius: "20px",
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "hidden",
                  }}
                >
                  <div
                    className="col-12 tableDesign"
                    style={{ background: "#2C78DB", overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative" }}
                  >
                    <table
                      className="m-0 p-0 BillsOutwardTable"
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                            fontSize: "18px",
                          }}
                        >
                          <th
                            style={{ minWidth: "70px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Sr.No.")}
                          </th>

                          <th
                            style={{ minWidth: "150px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Demand ID")}
                          </th>
 <th
                            style={{ minWidth: "150px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Head Code")}
                          </th>
                          <th
                            style={{ minWidth: "150px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Administrative Approved Year")}
                          </th>

                          <th
                            style={{ minWidth: "250px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Work Name")}
                          </th>

                          <th
                            style={{ minWidth: "150px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("District")}
                          </th>

                          <th
                            style={{ minWidth: "150px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Taluka")}
                          </th>

                          <th
                            style={{ minWidth: "180px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Work Approved GR")}
                          </th>

                          <th
                            style={{ minWidth: "220px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Technical Sanction Number")}
                          </th>

                          <th
                            style={{ minWidth: "220px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Beneficiary Name")}
                          </th>

                          {/* <th style={{ minWidth: "200px", padding: "8px" }} rowSpan={2}>
    {t("Bill Copy")}
</th>

<th style={{ minWidth: "200px", padding: "8px" }} rowSpan={2}>
    {t("Demand Copy")}
</th> */}

                          <th
                            style={{ minWidth: "150px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Bill Amount")}
                          </th>

                          <th
                            style={{ minWidth: "150px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Net Payable Amount")}
                          </th>

                          <th
                            style={{ minWidth: "150px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Deduction Amount")}
                          </th>

                          <th
                            style={{ minWidth: "180px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Bill Received Date")}
                          </th>

                          <th
                            style={{ minWidth: "180px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Uploaded Date")}
                          </th>

                          <th style={{ padding: "8px" }} colSpan={1}>
                            {t("Approved By")}
                          </th>
                        </tr>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                          }}
                        >
                          {/* <th style={{ minWidth: "150px", padding: "8px" }}>{t("Department Auditor")}</th>
                                                    <th style={{ minWidth: "150px", padding: "8px" }}>{t("Department HOD(EE)")}</th>
                                                    <th style={{ minWidth: "150px", padding: "8px" }}>{t("FD Auditor")}</th>
                                                    <th style={{ minWidth: "150px", padding: "8px" }}>{t("FD AAO")}</th>
                                                    <th style={{ minWidth: "150px", padding: "8px" }}>{t("FD AO")}</th>
                                                    <th style={{ minWidth: "150px", padding: "8px" }}>{t("Deputy CAFO")}</th>
                                                    <th style={{ minWidth: "150px", padding: "8px" }}>{t("CAFO")}</th> */}
                          <th style={{ minWidth: "150px", padding: "8px" }}>
                            {t("RDD")}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <>
                          {displayedGRS?.length === 0 ? (
                            <tr>
                              <td
                                colSpan="30"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {t("No data available")}
                              </td>
                            </tr>
                          ) : (
                            displayedGRS?.map((proposal, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                              return (
                                <tr
                                  style={{ backgroundColor: bgColor }}
                                  key={index}
                                >
                                  <td style={{ padding: "8px" ,fontSize: "18px",}}>
                                    {indexOfFirstBill + index + 1}
                                  </td>

                                  <td style={{ padding: "8px",fontSize: "18px", }}>
                                    {proposal.DemandGenerationID}
                                  </td>
      <td style={{ padding: "8px",fontSize: "18px" }}>
                                    {proposal.HeadCode}
                                  </td>
                                  <td style={{ padding: "8px",fontSize: "18px" }}>
                                    {proposal.AAYear}
                                  </td>

                                  <td style={{ padding: "8px",fontSize: "18px" }}>
                                    {proposal.WorkName}
                                  </td>

                                  <td style={{ padding: "8px",fontSize: "18px" }}>
                                    {proposal.District}
                                  </td>

                                  <td style={{ padding: "8px",fontSize: "18px" }}>
                                    {proposal.Taluka}
                                  </td>

                                  <td style={{ padding: "8px",fontSize: "18px" }}>
                                    {proposal.GROrderNo || "--"}
                                  </td>

                                  <td style={{ padding: "8px",fontSize: "18px" }}>
                                    {proposal.AANo || "--"}
                                  </td>

                                  <td style={{ padding: "8px",fontSize: "18px" }}>
                                    {proposal.BeneficiaryName}
                                  </td>

                                  {/* <td style={{ padding: '8px' }}>
        {
            proposal.BillCopy
                ? (
                    <a
                        href={`${apiurl}/BillCopyDocsImages/${proposal.BillCopy}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {proposal.BillCopy}
                    </a>
                )
                : (
                    <p className='fw-bold text-danger my-auto'>
                        {t("No File")}
                    </p>
                )
        }
    </td> */}

                                  {/* <td style={{ padding: '8px' }}>
        {
            proposal.WorkCopy
                ? (
                    <a
                        href={`${apiurl}/BillCopyDocsImages/${proposal.WorkCopy}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {proposal.WorkCopy}
                    </a>
                )
                : (
                    <p className='fw-bold text-danger my-auto'>
                        {t("No File")}
                    </p>
                )
        }
    </td> */}

                                  <td style={{ padding: "8px",fontSize: "18px" }}>
                                    ₹{" "}
                                    {Number(
                                      proposal.BillAmount || 0,
                                    ).toLocaleString("en-IN")}
                                  </td>

                                  <td style={{ padding: "8px",fontSize: "18px" }}>
                                    ₹{" "}
                                    {Number(
                                      proposal.NetPayableAmount || 0,
                                    ).toLocaleString("en-IN")}
                                  </td>

                                  <td style={{ padding: "8px" ,fontSize: "18px"}}>
                                    ₹{" "}
                                    {Number(
                                      proposal.DeductionAmount || 0,
                                    ).toLocaleString("en-IN")}
                                  </td>

                                  <td style={{fontSize: "18px"}}>
                                    {proposal.BillReceivedDate
                                      ? proposal.BillReceivedDate.split("-")
                                          .reverse()
                                          .join("-")
                                      : "NA"}
                                  </td>

                                  <td style={{ padding: "8px",fontSize: "18px" }}>
                                    {proposal.UploadedOn
                                      ? new Date(
                                          proposal.UploadedOn,
                                        ).toLocaleString("en-GB")
                                      : "-"}
                                  </td>

                                  <td style={{ padding: "8px" }}>
                                    {proposal.Approvance9 === "true" ? (
                                      <div
                                        className="m-auto"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          borderRadius: "6px",
                                          backgroundColor: "#16C60C",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          color: "white",
                                        }}
                                      >
                                        ✓
                                      </div>
                                    ) : (
                                      <div
                                        className="m-auto"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          borderRadius: "6px",
                                          backgroundColor: "#dc2626",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          color: "white",
                                        }}
                                      >
                                        ✕
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                          <tr
                            style={{
                              fontWeight: "600",
                              backgroundColor: "#f0f0f0",
                              fontSize: "18px",
                            }}
                          >
                            <td
                              colSpan={10}
                              style={{ textAlign: "right", padding: "8px" }}
                            >
                              {t("Page Total")}
                            </td>
 
                            <td style={{ padding: "8px" }}>
                              ₹ {pagetotalBillamt.toLocaleString("en-IN")}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹ {pagetotalpayableamt.toLocaleString("en-IN")}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹ {pagetotaldeductionamt.toLocaleString("en-IN")}
                            </td>
                            {/* remaining columns */}
                            <td colSpan={UserRole == "State" ? 19 : 20}></td>
                          </tr>
                            <tr
                            style={{
                              fontWeight: "600",
                              backgroundColor: "#f0f0f0",
                              fontSize: "18px",
                            }}
                          >
                            <td
                              colSpan={10}
                              style={{ textAlign: "right", padding: "8px" }}
                            >
                              {t("Gross Total")}
                            </td>
 
                            <td style={{ padding: "8px" }}>
                              ₹ {totalBillamt.toLocaleString("en-IN")}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹ {totalpayableamt.toLocaleString("en-IN")}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹ {totaldeductionamt.toLocaleString("en-IN")}
                            </td>
                            {/* remaining columns */}
                            <td colSpan={UserRole == "State" ? 19 : 20}></td>
                          </tr>

                          {/* old code */}
                          {/* <tr
                            style={{
                              fontWeight: "600",
                              backgroundColor: "#f0f0f0",
                              fontSize: "13px",
                            }}
                          >
                            <td
                              colSpan={9}
                              style={{ textAlign: "right", padding: "8px" }}
                            >
                              {t("Total")}
                            </td>

                            <td style={{ padding: "8px" }}>
                              ₹ {totalBillamt.toLocaleString("en-IN")}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹ {totalpayableamt.toLocaleString("en-IN")}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹ {totaldeductionamt.toLocaleString("en-IN")}
                            </td>
                            <td colSpan={UserRole == "State" ? 19 : 20}></td>
                          </tr> */}
                        </>
                      </tbody>
                    </table>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      height: "4rem",
                      alignItems: "center",
                    }}
                    className="mt-3"
                  >
                    <div>
                      <p className="text-gray-600" style={{ fontSize: "18px" }}>
                        {proposallist.length > 0
                          ? `Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, filteredBills.length)} of ${filteredBills.length} entries`
                          : "Showing 0 to 0 of 0 entries"}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />

                      <button
                        onClick={() => {
                          setShowAll(!showAll);
                          setCurrentPage(1);
                        }}
                        style={{
                          border: "none",
                          outline: "none",
                          cursor: "pointer",
                          padding: "8px 16px",
                          borderRadius: "20px",
                          fontSize: "18px",
                          fontWeight: "600",
                          color: "#fff",
                          background: showAll
                            ? "linear-gradient(135deg, #28a745, #20c997)"
                            : "linear-gradient(135deg, #0067ab, #0098d5)",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          transition: "all 0.3s ease",
                        }}
                      >
                        {showAll ? "✓ Showing All" : "View All"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {selectedProposal && (
            <div
              onClick={() => setSelectedProposal(null)}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.84)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  backgroundColor: "white",
                  padding: "40px 40px",
                  borderRadius: "20px",
                  width: "50%",
                  maxHeight: "90vh",
                  overflow: "hidden",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                  position: "relative",
                }}
              >
                <div className="col-12">
                  <div className="col-12  mb-3">
                    <div className="row">
                      <div className="col-6">
                        <h5 className="fw-bold">{t("Bill Details")}</h5>
                      </div>

                      <div
                        className="col-6"
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <button
                          onClick={() => setSelectedProposal(null)}
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            backgroundColor: "red",
                            border: "none",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: "24px",
                            fontWeight: "bold",
                            color: "white",
                            lineHeight: 1,
                          }}
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12"
                    style={{
                      height: "59vh",
                      overflowX: "hidden",
                      overflowY: "scroll",
                      scrollBehavior: "smooth",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        height: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <tbody>
                        {Object.entries(selectedProposal).map(
                          ([key, value], index) => (
                            <>
                              <tr
                                key={key}
                                style={{
                                  backgroundColor:
                                    index % 2 === 0 ? "#2B75D5" : "#cce0f9",
                                  border: "1px solid #cce0f9",
                                }}
                              >
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    padding: "8px",
                                    width: "40%",
                                    backgroundColor: "#2B75D5",
                                    color: "white",
                                    border: "1px solid #cce0f9",
                                  }}
                                >
                                  {key}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    color: "black",
                                    backgroundColor:
                                      index % 2 === 0 ? "#E3EBF5" : "#D0DEF1",
                                  }}
                                >
                                  {/* Handle Upload Bill Copy link */}
                                  {key === "Upload Demand Copy" && value ? (
                                    <a
                                      href={`${apiurl}/BillCopyDocsImages/${value}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {value}
                                    </a>
                                  ) : value === null || value === "" ? (
                                    "-"
                                  ) : (
                                    value.toString()
                                  )}
                                </td>
                              </tr>
                            </>
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.4)",
              backdropFilter: "blur(2px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="Adminloader"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewOldBills;

//--> old code

// import React, { useState, useEffect, useContext } from 'react'
// import AdminContext from '../../../StateContext/Application';
// // import { apiurl } from '../../../../path';
// import { Link } from 'react-router-dom';
// // import "./rejectpanel.css";
// import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../../public/LoginImages/importimages';
// import { apiurl } from '../../../../../path';
// import { useLanguage } from '../../../../../lang/langcontext/LanguageContext';
// import * as XLSX from 'xlsx';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import GooglePagination from '../../../styles/GooglePagination';

// const ViewOldBills = () => {
//     const { language, toggleLanguage, t } = useLanguage();
//     const context = useContext(AdminContext)
//     const { GetBudgetHeadInfo, TechnicalOutwards, Usermenu } = context;

//     const [technicalInwards, setTechnicalInwards] = useState([])
//     const [selectedBills, setSelectedBills] = useState([]);
//     const [filteredBills, setFilteredBills] = useState([]);
//     const [selectedProposal, setSelectedProposal] = useState(null);
//     const [proposallist, setProposalList] = useState([]);

//     console.log("technicalInwards", technicalInwards);

//     const [UserRole, setUserRole] = useState("");
//     const [AllDistrict, setAllDistrict] = useState([]);
//     const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
//     const [SelectedDistrict, setSelectedDistrict] = useState([]);
//     // const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] = useState("");
//     const [statusofData, setstatusofData] = useState("Sent to Bank");
//     const [statusofData1, setstatusofData1] = useState("");
//     const [RoleID, setroleID] = useState(null)
//     const [typeofData, settypeofData] = useState("District");
//     const [openDistrict, setOpenDistrict] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const billsPerPage = 10;
//     const [searchTerm, setSearchTerm] = useState('');
//     const budgetEstimation = proposallist;

//     const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
//     const indexOfLastBill = currentPage * billsPerPage;
//     const indexOfFirstBill = indexOfLastBill - billsPerPage;
//     const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

//     const [exportingPDF, setExportingPDF] = useState(false);
//     const [loading, setloading] = useState(false)
//     const displayedGRS = exportingPDF ? filteredBills : currentBills;

//     const headerStyle = {
//         padding: "12px 16px",
//         whiteSpace: "nowrap",
//         borderRight: "1px solid #e0e0e0",
//         textTransform: "capitalize",
//     };
//     const commonWidth = `${100 / 7}%`; // whatever the current width of Department Auditor looks like

//     const headerStyle1 = {
//         width: commonWidth,
//         padding: '12px 16px', whiteSpace: 'nowrap',
//         borderRight: '1px solid #e0e0e0',
//         textTransform: 'capitalize'
//     };

//     const cellStyle = {
//         width: commonWidth, // 100% / 7 columns
//         padding: '8px',
//         textAlign: 'center',
//         //   whiteSpace: 'nowrap'
//     };

//     const getTechnicalInwardsList = async () => {
//         let data = await GetBudgetHeadInfo('All', 'GetDemandGenerationList')
//         let data1 = await TechnicalOutwards("OldBill")
//         const { status, message, Tabletype } = data1

//         if (status) {
//             setTechnicalInwards(message)
//             setProposalList(message)
//             // setFilteredBills(message);
//             setUserRole(Tabletype);
//         }
//         else {
//             alert(message);
//         }

//     }
//     const getmenu = async () => {
//         try {
//             const data = await Usermenu();
//             if (!data || typeof data !== "object") {
//                 console.error("Invalid data:", data);
//                 return;
//             }
//             const roleID = data?.Data?.RoleID;
//             setroleID(roleID)
//             console.log("sffdsf", data?.Data)
//         } catch (error) {
//             console.error("Error in AdminNavbar getmenu:", error);
//         }
//     };
//     useEffect(() => {
//         getTechnicalInwardsList();
//         getmenu();
//     }, []);

//     const allDistricts = [
//         ...new Set(AllDistrict?.map(d => d.District_Marathi))
//     ];
//     const isAllSelected =
//         SelectedDistrict.length === allDistricts.length;

//     const toggleAllDistricts = () => {
//         setSelectedDistrict(isAllSelected ? [] : allDistricts);
//     };
//     const handleDistrictToggle = (district) => {
//         setSelectedDistrict(prev =>
//             prev.includes(district)
//                 ? prev.filter(d => d !== district)
//                 : [...prev, district]
//         );
//     };

//     useEffect(() => {
//         let filtered = [...technicalInwards];
//         console.log("All data ---> ", technicalInwards);
//         if (
//             typeofData === "District" &&
//             RoleID === 29
//         ) {
//             filtered = filtered.filter(
//                 (item) =>
//                     item.BudgetID ===
//                     "3054-2419(Roads and bridge repair maintenance program)",
//             );
//             console.log("filtered Date 3054", filtered)
//         } else if (
//             typeofData === "State" &&
//             RoleID === 29
//         ) {
//             filtered = filtered.filter(
//                 (item) => item.BudgetID === "2515-1238(MLA Representative)",
//             );
//         }
//         // 🔹 Filter by District (MULTI-SELECT)
//         if (SelectedDistrict?.length > 0) {
//             filtered = filtered.filter(item =>
//                 SelectedDistrict.includes(item.District)
//             );
//         }

//         // 🔹 Filter by Approval / Status
//         if (statusofData1) {
//             if (statusofData1 === "false") {
//                 filtered = filtered.filter(item =>
//                     item.Approvance1 === "false" ||
//                     item.Approvance2 === "false" ||
//                     item.Approvance3 === "false" ||
//                     item.Approvance4 === "false" ||
//                     item.Approvance5 === "false" ||
//                     item.Approvance6 === "false" ||
//                     item.Approvance9 === "false" ||
//                     item.Approvance8 === "false" ||
//                     item.Approvance9 === "false"
//                 );
//             }
//             else if (statusofData1 === "Approved") {   // ✅ Added block
//                 filtered = filtered.filter(item =>
//                     item.Approvance1 === "true" &&
//                     item.Approvance2 === "true" &&
//                     item.Approvance3 === "true" &&
//                     item.Approvance4 === "true" &&
//                     item.Approvance5 === "true" &&
//                     item.Approvance6 === "true" &&
//                     item.Approvance9 === "true" &&
//                     item.Approvance8 === "true" &&
//                     item.Approvance9 === "true"
//                 );
//             }
//             else if (statusofData1 === "Rejected") {
//                 filtered = filtered.filter(
//                     item => item.Status === "Rejected"
//                 );
//             }
//         }

//         console.log("Filter data ---> ", filtered);

//         // 🔹 Search Filter
//         if (searchTerm.trim()) {
//             const lower = searchTerm.toLowerCase();
//             filtered = filtered.filter(bill =>
//                 Object.values(bill).some(val =>
//                     String(val ?? "")
//                         .toLowerCase()
//                         .includes(lower)
//                 )
//             );
//         }

//         setFilteredBills(filtered);
//         setCurrentPage(1);

//     }, [
//         statusofData1,
//         searchTerm,
//         technicalInwards,
//         SelectedDistrict,
//         typeofData
//     ]);

//     const selectedBillDetails = (BillID) => {
//         const result = budgetEstimation
//             .filter(item => item.DemandGenerationID == BillID)
//             .map(item => ({
//                 "Demand ID": item.DemandGenerationID,
//                 "Bill Number": item.RABillNumber,
//                 "Proposal ID": item.ProjectID,
//                 "Head ID": item.BudgetID,
//                 "District": item.District,
//                 "Contractor Name": item.ContractorName,
//                 "Work Order UID": item.WorkOrderUID,
//                 "Upload Demand Copy": item.UploadBillCopy,
//                 "Remark": item.Remark,
//                 "Bill Amount": item.BillAmount,
//                 "Net Payable Amount": item.NetPayableAmount,
//                 "Deduction Amount": item.DeductionAmount,
//                 "Date": new Date(item.Date).toLocaleString(),
//             }));

//         console.log("------------------", result)
//         setSelectedProposal(result[0]);
//     }

//     const FetchGramPanachayatInfo = async () => {
//         try {
//             let res = await GetBudgetHeadInfo('null', "AllDistrict");
//             // console.log("Data i get:: ", res);
//             setAllDistrict(res);
//         }
//         catch (err) {
//             console.log(err);
//         }
//     }

//     useEffect(() => {
//         FetchGramPanachayatInfo();
//     }, []);

//     const totalBillamt = filteredBills?.reduce((sum, item) => {
//         const amount = Number(item?.BillAmount);
//         return sum + (isNaN(amount) ? 0 : amount);
//     }, 0);
//     const totalpayableamt = filteredBills?.reduce((sum, item) => {
//         const amount = Number(item?.NetPayableAmount);
//         return sum + (isNaN(amount) ? 0 : amount);
//     }, 0);
//     const totaldeductionamt = filteredBills?.reduce((sum, item) => {
//         const amount = Number(item?.DeductionAmount);
//         return sum + (isNaN(amount) ? 0 : amount);
//     }, 0);

//     const exportTableByClassToExcel = async (
//         bills,
//         filename = "Bills_Outward.xlsx"
//     ) => {
//         if (!bills || bills.length === 0) {
//             alert("No data available");
//             return;
//         }

//         setloading(true);
//         await new Promise((resolve) => setTimeout(resolve, 1000));
//         try {
//             const getStatus = (val) =>
//                 val === "true" ? "✓" : val === "false" ? "✕" : "-";

//             const excelData = bills.map((proposal, index) => ({
//                 "Sr.No.": index + 1,
//                 "Demand ID": proposal.DemandGenerationID,
//                 "Bill Number": proposal.RABillNumber,
//                 "Head ID": proposal.BudgetID,
//                 "Work Name": proposal.ProjectID,
//                 "Technical Sanction Number": proposal.BillNumber,
//                 "Physical Progress(in %)": proposal.physicalValueOfProgress,
//                 "District": proposal.District,
//                 "Vendor Name": proposal.ContractorName,
//                 "Upload Demand Copy": proposal.UploadBillCopy || "No File",
//                 "Demand Copy": proposal.BillCopy || "No File",
//                 "Remark": proposal.Remark || "",
//                 "Bill Amount": proposal.BillAmount || 0,
//                 "Net Payable Amount": proposal.NetPayableAmount || 0,
//                 "Deduction Amount": proposal.DeductionAmount || 0,
//                 "Date": proposal.Date
//                     ? new Date(proposal.Date).toLocaleString()
//                     : "",
//                 "Department Auditor": getStatus(proposal.Approvance1),
//                 "Department HOD(EE)": getStatus(proposal.Approvance2),
//                 "FD Auditor": getStatus(proposal.Approvance3),
//                 "FD AAO": getStatus(proposal.Approvance4),
//                 "FD AO": getStatus(proposal.Approvance5),
//                 "Deputy CAFO": getStatus(proposal.Approvance6),
//                 "CAFO": getStatus(proposal.Approvance9),
//             }));

//             /* 🔢 TOTAL ROW */
//             const totalRow = {
//                 "Sr.No.": "Total",
//                 "Demand ID": "",
//                 "Bill Number": "",
//                 "Head ID": "",
//                 "Work Name": "",
//                 "Technical Sanction Number": "",
//                 "Physical Progress(in %)": "",
//                 "District": "",
//                 "Vendor Name": "",
//                 "Upload Demand Copy": "",
//                 "Demand Copy": "",
//                 "Remark": "",
//                 "Bill Amount": bills.reduce(
//                     (sum, b) => sum + Number(b.BillAmount || 0),
//                     0
//                 ),
//                 "Net Payable Amount": bills.reduce(
//                     (sum, b) => sum + Number(b.NetPayableAmount || 0),
//                     0
//                 ),
//                 "Deduction Amount": bills.reduce(
//                     (sum, b) => sum + Number(b.DeductionAmount || 0),
//                     0
//                 ),
//                 "Date": "",
//                 "Department Auditor": "",
//                 "Department HOD(EE)": "",
//                 "FD Auditor": "",
//                 "FD AAO": "",
//                 "FD AO": "",
//                 "Deputy CAFO": "",
//                 "CAFO": "",
//             };

//             excelData.push(totalRow);

//             const worksheet = XLSX.utils.json_to_sheet(excelData);

//             /* Column width */
//             worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({
//                 wch: 22,
//             }));

//             /* Freeze header */
//             worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

//             /* Filter */
//             worksheet["!autofilter"] = {
//                 ref: XLSX.utils.encode_range({
//                     s: { r: 0, c: 0 },
//                     e: {
//                         r: excelData.length,
//                         c: Object.keys(excelData[0]).length - 1,
//                     },
//                 }),
//             };

//             const workbook = XLSX.utils.book_new();
//             XLSX.utils.book_append_sheet(workbook, worksheet, "Bills");
//             XLSX.writeFile(workbook, filename);
//         } catch (error) {
//             console.error("Excel Export Error:", error);
//         } finally {
//             setloading(false); // ✅ ALWAYS stop loader
//         }
//     };

//     const downloadTableOnlyAsPDF = async (
//         tableClass,
//         filename,
//         title,
//         chunkSize = 500 // 🔥 300–500 recommended
//     ) => {
//         const originalTable = document.querySelector(`.${tableClass}`);
//         if (!originalTable) {
//             setExportingPDF(false);
//             return;
//         }

//         setloading(true);
//         setExportingPDF(true);

//         // Allow loader to render first
//         await new Promise((resolve) => setTimeout(resolve, 600));

//         try {
//             const originalRows = originalTable.querySelectorAll("tbody tr");
//             const totalRows = originalRows.length;

//             if (!totalRows) {
//                 setloading(false);
//                 setExportingPDF(false);
//                 return;
//             }

//             for (let start = 0; start < totalRows; start += chunkSize) {
//                 const end = Math.min(start + chunkSize, totalRows);

//                 // 🔥 Clone table cleanly
//                 const tableClone = originalTable.cloneNode(true);
//                 const rows = tableClone.querySelectorAll("tbody tr");

//                 // Remove rows outside current chunk
//                 rows.forEach((row, index) => {
//                     if (index < start || index >= end) {
//                         row.remove();
//                     }
//                 });

//                 // Hide cloned table from view
//                 tableClone.style.position = "absolute";
//                 tableClone.style.left = "-9999px";
//                 tableClone.style.top = "0";
//                 document.body.appendChild(tableClone);

//                 const pdf = new jsPDF("p", "mm", "a4");
//                 const pageWidth = pdf.internal.pageSize.getWidth();
//                 const pageHeight = pdf.internal.pageSize.getHeight();

//                 const topMargin = 25;
//                 const sideMargin = 10;
//                 const bottomMargin = 15;

//                 pdf.setFontSize(16);
//                 pdf.setFont("helvetica", "bold");
//                 pdf.text(
//                     `${title} (${start + 1} - ${end})`,
//                     pageWidth / 2,
//                     15,
//                     { align: "center" }
//                 );

//                 const canvas = await html2canvas(tableClone, {
//                     scale: 1,
//                     useCORS: true,
//                     backgroundColor: "#2C78DB",
//                 });

//                 const imgWidth = pageWidth - sideMargin * 2;
//                 const pxToMm = imgWidth / canvas.width;

//                 const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
//                 const usablePageHeightPx = usablePageHeightMm / pxToMm;

//                 let renderedHeight = 0;
//                 let pageNumber = 0;

//                 while (renderedHeight < canvas.height) {
//                     const sliceHeight = Math.min(
//                         usablePageHeightPx,
//                         canvas.height - renderedHeight
//                     );

//                     const pageCanvas = document.createElement("canvas");
//                     const context = pageCanvas.getContext("2d");

//                     pageCanvas.width = canvas.width;
//                     pageCanvas.height = sliceHeight;

//                     context.drawImage(
//                         canvas,
//                         0,
//                         renderedHeight,
//                         canvas.width,
//                         sliceHeight,
//                         0,
//                         0,
//                         canvas.width,
//                         sliceHeight
//                     );

//                     const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

//                     if (pageNumber > 0) pdf.addPage();

//                     pdf.addImage(
//                         imgData,
//                         "JPEG",
//                         sideMargin,
//                         topMargin,
//                         imgWidth,
//                         sliceHeight * pxToMm
//                     );

//                     renderedHeight += sliceHeight;
//                     pageNumber++;
//                 }

//                 pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

//                 document.body.removeChild(tableClone);

//                 // Small delay prevents UI freezing
//                 await new Promise((resolve) => setTimeout(resolve, 300));
//             }
//         } catch (error) {
//             console.error("PDF Export Error:", error);
//         } finally {
//             setExportingPDF(false);
//             setloading(false);
//         }
//     };

//     return (

//         <>
//             {
//                 false &&
//                 <div>

//                     <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
//                         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80vw", maxWidth: "1200px", marginBottom: "15px" }}>
//                             <h4 style={{ margin: "10px" }}>{t("Bill List")}</h4>
//                             <input type="text" placeholder={t("Search")} onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} />
//                         </div>

//                         <div style={{ display: "grid", justifyContent: "center", boxShadow: "0px 0px 3px", borderRadius: "20px", width: "78vw", }}>
//                             <div style={{ overflowX: "auto", width: "78vw", borderRadius: "20px", }}>
//                                 <table style={{ backgroundColor: "white", width: "130%", borderRadius: "20px", overflow: "hidden", borderCollapse: "collapse", }}>
//                                     <thead style={{ borderTop: "none" }}>
//                                         <tr style={{ background: 'linear-gradient(to bottom, #CCEAF7, #CFE4F1, #CCE1EE, #D8D9EC)', color: "black", border: "none", borderRadius: "10px", overflow: "hidden", height: "3rem", fontSize: "12px", textAlign: "center", }}>
//                                             <th style={{ width: "6%" }}>{t("Bill UID")}</th>
//                                             <th style={{ width: "7%" }}>{t("HeadCode Name")}</th>
//                                             <th style={{ width: "8%" }}>{t("Proposal UID")}</th>
//                                             <th style={{ width: "7%" }}>{t("RA Bill Number")}</th>
//                                             <th style={{ width: "6%" }}>{t("District")}</th>
//                                             <th style={{ width: "10%" }}>{t("Vendor Name")}</th>
//                                             <th style={{ width: "8%" }}>{t("Bill Amount")}</th>
//                                             <th style={{ width: "8%" }}>{t("Deduction Amount")}</th>
//                                             <th style={{ width: "8%" }}>{t("Payable Amount")}</th>
//                                             <th style={{ width: "8%" }}>{t("Remark")}</th>
//                                             <th style={{ width: "14%" }}>{t("Uploaded Files")}</th>
//                                             <th style={{ width: "10%" }}>{t("Date")}</th>

//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {
//                                             currentBills?.map((technicalInwards, index) => {
//                                                 const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                 return (
//                                                     <tr className='px-3' key={index} style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
//                                                         <td className='py-2'>{technicalInwards.DemandGenerationID}</td>
//                                                         <td className='py-2'>{technicalInwards.BudgetID}</td>
//                                                         <td className='py-2'>{technicalInwards.ProjectID}</td>
//                                                         <td className='py-2'>{technicalInwards.RABillNumber}</td>
//                                                         <td className='py-2'>{technicalInwards.District}</td>
//                                                         <td className='py-2'>{technicalInwards.ContractorName}</td>
//                                                         <td className='py-2'>{technicalInwards.BillAmount / 10000000} CR</td>
//                                                         <td className='py-2'>{technicalInwards.DeductionAmount / 10000000} CR</td>
//                                                         <td className='py-2'>{technicalInwards.NetPayableAmount / 10000000} CR</td>
//                                                         <td className='py-2'>{technicalInwards.Remark ? technicalInwards.Remark : <p className='text-danger fw-bold my-auto'>{t("No Remark")}</p>}</td>
//                                                         <td style={{ padding: '8px' }}>
//                                                             {technicalInwards.UploadBillCopy ? (
//                                                                 <a href={`${apiurl}/BillCopyDocsImages/${technicalInwards.UploadBillCopy}`} target="_blank" rel="noreferrer">{technicalInwards.UploadBillCopy}</a>
//                                                             ) : (
//                                                                 <p className='text-danger my-auto fw-bold'>{t("No File")}</p>
//                                                             )
//                                                             }
//                                                         </td>
//                                                         <td className='py-2'>{new Date(technicalInwards.Date).toLocaleString()}</td>

//                                                     </tr>
//                                                 )
//                                             })
//                                         }
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>

//                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

//                             <div className='ms-auto' style={{ display: 'flex', justifyContent: 'space-evenly', margin: '10px 0' }}>
//                                 <button
//                                     onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                                     disabled={currentPage === 1}
//                                     style={{ padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === 1 ? '#ccc' : 'blue', color: 'white' }}
//                                 >
//                                     {t("Previous")}
//                                 </button>
//                                 <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                                     {t("Page")} {currentPage} {t("of")} {totalPages}
//                                 </span>
//                                 <button
//                                     onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
//                                     disabled={currentPage === totalPages}
//                                     style={{ padding: '6px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === totalPages ? '#ccc' : 'blue', color: 'white' }}
//                                 >
//                                     {t("Next")}
//                                 </button>
//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             }

//             {
//                 false &&
//                 (
//                     <div className='col-12' style={{ display: "grid", justifyContent: "center", maxWidth: "100%" }}>
//                         <div className='col-12 mb-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                             <h4 className='my-auto'>{t("Bill Outwards")}</h4>
//                             <input
//                                 type="text"
//                                 placeholder={t("Search Here")}
//                                 onChange={(e) => setSearchTerm(e.target.value)}
//                                 value={searchTerm}
//                                 style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }}
//                             />
//                         </div>
//                         <div className='col-12' style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', overflowX: "auto", border: '1px solid #3b409e' }}>
//                             <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "1200px" }}>
//                                 <thead>
//                                     <tr style={{ color: 'white', border: 'none', height: '3.5rem' }}>
//                                         <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("Bill Number")}</th>
//                                         <th style={{ width: "80%", border: "1px solid white" }} colSpan={9}>{t("Approved by")}</th> {/* changed from 9 to 8 */}
//                                         <th style={{ width: "10%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>{t("Details")}</th>
//                                     </tr>
//                                     <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
//                                         <th style={{ minWidth: "150px", padding: "8px" }}>{t("Department Auditor")}</th>
//                                         <th style={{ minWidth: "150px", padding: "8px" }}>{t("Department HOD(EE)")}</th>
//                                         <th style={{ minWidth: "150px", padding: "8px" }}>{t("FD Auditor")}</th>
//                                         <th style={{ minWidth: "150px", padding: "8px" }}>{t("FD AAO")}</th>
//                                         <th style={{ minWidth: "150px", padding: "8px" }}>{t("FD AO")}</th>
//                                         <th style={{ minWidth: "150px", padding: "8px" }}>{t("Deputy CAFO")}</th>
//                                         <th style={{ minWidth: "150px", padding: "8px" }}>{t("CAFO")}</th>
//                                         <th style={{ minWidth: "150px", padding: "8px" }}>{t("RDD")}</th>
//                                         {/* <th style={{ minWidth: "150px", padding: "8px" }}>{t("RDD Section Officer ")}</th> */}
//                                     </tr>
//                                 </thead>

//                                 <tbody >
//                                     {currentBills?.length === 0 ? (
//                                         <tr>
//                                             <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                                                 {t("No data available")}
//                                             </td>
//                                         </tr>
//                                     ) : (
//                                         currentBills?.map((proposal, index) => {
//                                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                             return (
//                                                 <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor }} key={proposal.DemandGenerationID || index}>
//                                                     <td style={{ padding: '8px' }}>{proposal.RABillNumber}</td>
//                                                     <td style={{ padding: '8px', textAlign: 'center', borderRight: '1px solid #3b409e' }}>
//                                                         {proposal.Approvance1 === 'true' ? '✅' : proposal.Approvance1 === 'false' ? '❌' : '-'}
//                                                     </td>
//                                                     <td style={{ padding: '8px', textAlign: 'center', borderRight: '1px solid #3b409e' }}>
//                                                         {proposal.Approvance2 === 'true' ? '✅' : proposal.Approvance2 === 'false' ? '❌' : '-'}
//                                                     </td>
//                                                     <td style={cellStyle}>
//                                                         {proposal.Approvance3 === 'true' ? '✅' : proposal.Approvance3 === 'false' ? '❌' : '-'}
//                                                     </td>
//                                                     <td style={cellStyle}>
//                                                         {proposal.Approvance4 === 'true' ? '✅' : proposal.Approvance4 === 'false' ? '❌' : '-'}
//                                                     </td>
//                                                     <td style={cellStyle}>
//                                                         {proposal.Approvance5 === 'true' ? '✅' : proposal.Approvance5 === 'false' ? '❌' : '-'}
//                                                     </td>
//                                                     <td style={cellStyle}>
//                                                         {proposal.Approvance6 === 'true' ? '✅' : proposal.Approvance6 === 'false' ? '❌' : '-'}
//                                                     </td>
//                                                     <td style={cellStyle}>
//                                                         {proposal.Approvance7 === 'true' ? '✅' : proposal.Approvance7 === 'false' ? '❌' : '-'}
//                                                     </td>
//                                                     {/* <td style={cellStyle}>
//                                                         {proposal.Approvance8 === 'true' ? '✅' : proposal.Approvance8 === 'false' ? '❌' : '-'}
//                                                     </td> */}
//                                                     <td style={cellStyle}>
//                                                         {proposal.Approvance9 === 'true' ? '✅' : proposal.Approvance9 === 'false' ? '❌' : '-'}
//                                                     </td>
//                                                     {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
//                                                     <td>
//                                                         <button
//                                                             onClick={() => selectedBillDetails(proposal.DemandGenerationID)}
//                                                             style={{
//                                                                 cursor: 'pointer',
//                                                                 backgroundColor: '#0098d5',
//                                                                 color: 'white',
//                                                                 border: 'none',
//                                                                 padding: '5px 10px',
//                                                                 borderRadius: '4px'
//                                                             }}
//                                                         >
//                                                             {t("View")}
//                                                         </button>
//                                                     </td>
//                                                 </tr>

//                                             );
//                                         })
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>

//                         <div className='col-12' style={{ display: 'flex', justifyContent: 'space-between', height: '3rem', alignItems: 'center' }}>
//                             <div>
//                                 <p>
//                                     {t("Showing")} {currentBills?.length || 0} {t("of")} {proposallist?.length || 0} {t("entries")}
//                                 </p>
//                             </div>
//                             <div style={{ display: 'flex', alignItems: 'center' }}>
//                                 <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
//                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px' }}>&laquo;</button>
//                                 <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
//                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&lt;</button>
//                                 <button
//                                     style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', border: '1px solid lightgrey', borderLeft: "none" }}>
//                                     {currentPage}
//                                 </button>
//                                 <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
//                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&gt;</button>
//                                 <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
//                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&raquo;</button>
//                             </div>
//                         </div>

//                         {selectedProposal && (
//                             <div
//                                 onClick={() => setSelectedProposal(null)}
//                                 style={{
//                                     position: 'fixed',
//                                     top: 0, left: 0,
//                                     width: '100vw',
//                                     height: '100vh',
//                                     backgroundColor: 'rgba(0,0,0,0.5)',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     zIndex: 9999,
//                                 }}
//                             >
//                                 <div
//                                     onClick={(e) => e.stopPropagation()}
//                                     style={{
//                                         backgroundColor: 'white',
//                                         padding: '20px',
//                                         borderRadius: '8px',
//                                         maxWidth: '600px',
//                                         width: '90%',
//                                         maxHeight: '80vh',
//                                         overflowY: 'auto',
//                                         boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//                                         position: 'relative'
//                                     }}
//                                 >
//                                     <h3>{t("Bill Details")}</h3>
//                                     <button
//                                         onClick={() => setSelectedProposal(null)}
//                                         style={{
//                                             position: 'absolute',
//                                             top: '10px',
//                                             right: '10px',
//                                             background: 'transparent',
//                                             border: 'none',
//                                             fontSize: '20px',
//                                             cursor: 'pointer',
//                                         }}
//                                     >
//                                         &times;
//                                     </button>
//                                     <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                         <tbody>
//                                             {Object.entries(selectedProposal).map(([key, value]) => (
//                                                 <tr key={key} style={{ borderBottom: '1px solid #ddd' }}>
//                                                     <td style={{ fontWeight: 'bold', padding: '8px', width: '40%', backgroundColor: '#f0f0f0' }}>
//                                                         {key}
//                                                     </td>
//                                                     <td style={{ padding: '8px' }}>

//                                                         {
//                                                             key == "Bill Number" && value ? value : "--"
//                                                         }
//                                                         {/* Handle Upload Bill Copy link */}
//                                                         {key === 'Upload Demand Copy' && value ? (
//                                                             <a
//                                                                 href={`${apiurl}/BillCopyDocsImages/${value}`}
//                                                                 target="_blank"
//                                                                 rel="noreferrer"
//                                                             >
//                                                                 {value}
//                                                             </a>
//                                                         ) : value === null || value === '' ? (
//                                                             '-'
//                                                         ) : (
//                                                             value.toString()
//                                                         )}
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                 )
//             }

//             <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll", position: "relative" }}>
//                 <div
//                     style={{
//                         filter: loading ? "blur(4px)" : "none",
//                         pointerEvents: loading ? "none" : "auto",
//                         transition: "0.2s ease",
//                     }}
//                 >
//                     <div className="col-11 m-auto">
//                         <div className='col-12 '>
//                             <div
//                                 className="col-12 px-4 mb-4 mt-3"
//                                 style={{
//                                     filter: loading ? "blur(4px)" : "none",
//                                     pointerEvents: loading ? "none" : "auto",
//                                     transition: "0.2s ease",
//                                 }}
//                             >

//                                 {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
//                                 <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
//                                     <h5 className="fw-bold d-flex align-items-center m-0">
//                                         <img
//                                             src="/GR-Approval64.png"
//                                             alt="Technical Approval"
//                                             style={{ width: "24px", height: "24px", marginRight: "6px" }}
//                                         />
//                                          {t("Pending Bills Outward")}
//                                     </h5>

//                                     <div className="d-flex gap-2">
//                                         <button
//                                             className="btn btn-success"
//                                             onClick={() =>
//                                                 exportTableByClassToExcel(filteredBills, "Bills_Outward.xlsx")
//                                             }
//                                         >
//                                             {t("Download Excel")}
//                                         </button>

//                                         <button
//                                             className="btn btn-danger"
//                                             onClick={() =>
//                                                 downloadTableOnlyAsPDF(
//                                                     "BillsOutwardTable",
//                                                     "Bills_Outward.pdf",
//                                                     "Bills Outward Report"
//                                                 )
//                                             }
//                                         >
//                                             {t("Download PDF")}
//                                         </button>
//                                     </div>
//                                 </div>

//                                 {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
//                                 <div
//                                     style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "8px",
//                                         flexWrap: "nowrap"
//                                     }}
//                                 >
//                                     {UserRole === "State" && RoleID == 29 && (
//                                         <select
//                                             value={typeofData}
//                                             onChange={(e) => settypeofData(e.target.value)}
//                                             style={{
//                                                 width: "150px",
//                                                 padding: "8px",
//                                                 border: "1px solid #ccc",
//                                                 borderRadius: "8px",
//                                                 fontSize: "13px", whiteSpace: "nowrap",
//                                                 overflow: "hidden",
//                                                 textOverflow: "ellipsis"
//                                             }}
//                                         >
//                                             <option value="" disabled selected>
//                                                 Choose Data
//                                             </option>
//                                             <option value="District" >{t("3054-2419(Roads and bridge repair maintenance program)")}</option>
//                                             <option value="State">{t("2515-1238(MLA Representative)")}</option>
//                                         </select>
//                                     )}
//                                     {/* Status */}
//                                     <select
//                                         value={statusofData1}
//                                         onChange={(e) => setstatusofData1(e.target.value)}
//                                         style={{
//                                             width: "150px",
//                                             padding: "8px",
//                                             border: "1px solid #ccc",
//                                             borderRadius: "8px",
//                                             fontSize: "13px",
//                                             whiteSpace: "nowrap",
//                                             overflow: "hidden",
//                                             textOverflow: "ellipsis"
//                                         }}
//                                     >
//                                         <option value="">{t("All")}</option>
//                                         <option value="Approved">{t("Approved")}</option>
//                                         <option value="false">{t("Pending")}</option>
//                                         <option value="Rejected">{t("Rejected")}</option>
//                                     </select>

//                                     {/* District */}
//                                     {UserRole === "State" && (
//                                         <div style={{ position: "relative", width: "160px" }}>
//                                             {/* Dropdown trigger */}
//                                             <div
//                                                 onClick={() => setOpenDistrict(!openDistrict)}
//                                                 style={{
//                                                     padding: "8px",
//                                                     border: "1px solid #ccc",
//                                                     borderRadius: "8px",
//                                                     background: "#fff",
//                                                     cursor: "pointer",
//                                                     fontSize: "13px",
//                                                     whiteSpace: "nowrap",
//                                                     overflow: "hidden",
//                                                     textOverflow: "ellipsis"
//                                                 }}
//                                             >
//                                                 {SelectedDistrict.length > 0
//                                                     ? SelectedDistrict.join(", ")
//                                                     : "Select District"}
//                                             </div>

//                                             {/* Dropdown list */}
//                                             {openDistrict && (
//                                                 <div
//                                                     style={{
//                                                         position: "absolute",
//                                                         top: "100%",
//                                                         left: 0,
//                                                         width: "100%",
//                                                         background: "#fff",
//                                                         border: "1px solid #ccc",
//                                                         borderRadius: "8px",
//                                                         marginTop: "4px",
//                                                         zIndex: 1000
//                                                     }}
//                                                 >
//                                                     <label
//                                                         style={{
//                                                             display: "flex",
//                                                             alignItems: "center",
//                                                             padding: "6px 8px",
//                                                             borderBottom: "1px solid #eee",
//                                                             cursor: "pointer",
//                                                             fontSize: "13px", whiteSpace: "nowrap",
//                                                             overflow: "hidden",
//                                                             textOverflow: "ellipsis"
//                                                         }}
//                                                     >
//                                                         <input
//                                                             type="checkbox"
//                                                             checked={isAllSelected}
//                                                             onChange={toggleAllDistricts}
//                                                             style={{ marginRight: "6px" }}
//                                                         />
//                                                         {t("All Districts")}
//                                                     </label>
//                                                     <div style={{ maxHeight: "150px", overflowY: "auto" }}>
//                                                         {[...new Set(AllDistrict?.map(d => d.District_Marathi))].map(
//                                                             (district, index) => (
//                                                                 <label
//                                                                     key={index}
//                                                                     style={{
//                                                                         display: "flex",
//                                                                         alignItems: "center",
//                                                                         padding: "6px 8px",
//                                                                         cursor: "pointer",
//                                                                         fontSize: "13px", whiteSpace: "nowrap",
//                                                                         overflow: "hidden",
//                                                                         textOverflow: "ellipsis"
//                                                                     }}
//                                                                 >
//                                                                     <input
//                                                                         type="checkbox"
//                                                                         checked={SelectedDistrict.includes(district)}
//                                                                         onChange={() => handleDistrictToggle(district)}
//                                                                         onClick={(e) => e.stopPropagation()}
//                                                                         style={{ marginRight: "6px" }}
//                                                                     />
//                                                                     {district}
//                                                                 </label>
//                                                             )
//                                                         )}
//                                                     </div>

//                                                     {/* Footer */}
//                                                     <div style={{ padding: "6px", textAlign: "right", borderTop: "1px solid #eee" }}>
//                                                         <button
//                                                             onClick={() => setOpenDistrict(false)}
//                                                             style={{
//                                                                 padding: "4px 10px",
//                                                                 fontSize: "12px",
//                                                                 border: "none",
//                                                                 borderRadius: "6px",
//                                                                 background: "#0d6efd",
//                                                                 color: "#fff",
//                                                                 cursor: "pointer"
//                                                             }}
//                                                         >
//                                                             OK
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     )}

//                                     {/* Search */}
//                                     <div style={{ position: "relative", width: "220px" }}>
//                                         <img
//                                             src="/Search32.png"
//                                             alt="Search"
//                                             style={{
//                                                 position: "absolute",
//                                                 top: "50%",
//                                                 left: "10px",
//                                                 transform: "translateY(-50%)",
//                                                 width: "16px",
//                                                 opacity: 0.6
//                                             }}
//                                         />
//                                         <input
//                                             type="text"
//                                             placeholder={t("Search Here")}
//                                             value={searchTerm}
//                                             onChange={(e) => setSearchTerm(e.target.value)}
//                                             style={{
//                                                 width: "100%",
//                                                 padding: "8px 12px 8px 32px",
//                                                 border: "1px solid #ccc",
//                                                 borderRadius: "8px",
//                                                 backgroundColor: "#f1f6fc",
//                                                 fontSize: "13px", whiteSpace: "nowrap",
//                                                 overflow: "hidden",
//                                                 textOverflow: "ellipsis"
//                                             }}
//                                         />
//                                     </div>

//                                 </div>
//                             </div>

//                             <div className='col-12 pb-5'>
//                                 <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                                     <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
//                                         <table className='m-0 p-0 BillsOutwardTable' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                             <thead>
//                                                 <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                                                     <th style={{ minWidth: "70px", padding: "8px" }} rowSpan={2}>
//     {t("Sr.No.")}
// </th>

// <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2}>
//     {t("Demand ID")}
// </th>

// <th style={{ minWidth: "250px", padding: "8px" }} rowSpan={2}>
//     {t("Work Name")}
// </th>

// <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2}>
//     {t("District")}
// </th>

// <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2}>
//     {t("Taluka")}
// </th>

// <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2}>
//     {t("Work Approved Year")}
// </th>

// <th style={{ minWidth: "180px", padding: "8px" }} rowSpan={2}>
//     {t("Work Approved GR")}
// </th>

// <th style={{ minWidth: "220px", padding: "8px" }} rowSpan={2}>
//     {t("Technical Sanction Number")}
// </th>

// <th style={{ minWidth: "220px", padding: "8px" }} rowSpan={2}>
//     {t("Beneficiary Name")}
// </th>

// {/* <th style={{ minWidth: "200px", padding: "8px" }} rowSpan={2}>
//     {t("Bill Copy")}
// </th>

// <th style={{ minWidth: "200px", padding: "8px" }} rowSpan={2}>
//     {t("Demand Copy")}
// </th> */}

// <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2}>
//     {t("Bill Amount")}
// </th>

// <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2}>
//     {t("Net Payable Amount")}
// </th>

// <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2}>
//     {t("Deduction Amount")}
// </th>

// <th style={{ minWidth: "180px", padding: "8px" }} rowSpan={2}>
//     {t("Uploaded Date")}
// </th>

// <th style={{ padding: "8px" }} colSpan={1}>
//     {t("Approved By")}
// </th>
//                                                 </tr>
//                                                 <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
//                                                     {/* <th style={{ minWidth: "150px", padding: "8px" }}>{t("Department Auditor")}</th>
//                                                     <th style={{ minWidth: "150px", padding: "8px" }}>{t("Department HOD(EE)")}</th>
//                                                     <th style={{ minWidth: "150px", padding: "8px" }}>{t("FD Auditor")}</th>
//                                                     <th style={{ minWidth: "150px", padding: "8px" }}>{t("FD AAO")}</th>
//                                                     <th style={{ minWidth: "150px", padding: "8px" }}>{t("FD AO")}</th>
//                                                     <th style={{ minWidth: "150px", padding: "8px" }}>{t("Deputy CAFO")}</th>
//                                                     <th style={{ minWidth: "150px", padding: "8px" }}>{t("CAFO")}</th> */}
//                                                     <th style={{ minWidth: "150px", padding: "8px" }}>{t("RDD")}</th>
//                                                 </tr>
//                                             </thead>

//                                             <tbody >
//                                                 <>
//                                                     {displayedGRS?.length === 0 ? (
//                                                         <tr>
//                                                             <td colSpan="30" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                                                                 {t("No data available")}
//                                                             </td>
//                                                         </tr>
//                                                     ) : (
//                                                         displayedGRS?.map((proposal, index) => {
//                                                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                             return (
//                                                                 <tr style={{ backgroundColor: bgColor }} key={index}>

//     <td style={{ padding: '8px' }}>
//         {indexOfFirstBill + index + 1}
//     </td>

//     <td style={{ padding: '8px' }}>
//         {proposal.DemandGenerationID}
//     </td>

//     <td style={{ padding: '8px' }}>
//         {proposal.WorkName}
//     </td>

//     <td style={{ padding: '8px' }}>
//         {proposal.District}
//     </td>

//     <td style={{ padding: '8px' }}>
//         {proposal.Taluka}
//     </td>

//     <td style={{ padding: '8px' }}>
//         {proposal.AAYear}
//     </td>

//     <td style={{ padding: '8px' }}>
//         {proposal.GROrderNo}
//     </td>

//     <td style={{ padding: '8px' }}>
//         {proposal.AANo}
//     </td>

//     <td style={{ padding: '8px' }}>
//         {proposal.BeneficiaryName}
//     </td>

//     {/* <td style={{ padding: '8px' }}>
//         {
//             proposal.BillCopy
//                 ? (
//                     <a
//                         href={`${apiurl}/BillCopyDocsImages/${proposal.BillCopy}`}
//                         target="_blank"
//                         rel="noreferrer"
//                     >
//                         {proposal.BillCopy}
//                     </a>
//                 )
//                 : (
//                     <p className='fw-bold text-danger my-auto'>
//                         {t("No File")}
//                     </p>
//                 )
//         }
//     </td> */}

//     {/* <td style={{ padding: '8px' }}>
//         {
//             proposal.WorkCopy
//                 ? (
//                     <a
//                         href={`${apiurl}/BillCopyDocsImages/${proposal.WorkCopy}`}
//                         target="_blank"
//                         rel="noreferrer"
//                     >
//                         {proposal.WorkCopy}
//                     </a>
//                 )
//                 : (
//                     <p className='fw-bold text-danger my-auto'>
//                         {t("No File")}
//                     </p>
//                 )
//         }
//     </td> */}

//     <td style={{ padding: '8px' }}>
//         ₹ {Number(proposal.BillAmount || 0).toLocaleString("en-IN")}
//     </td>

//     <td style={{ padding: '8px' }}>
//         ₹ {Number(proposal.NetPayableAmount || 0).toLocaleString("en-IN")}
//     </td>

//     <td style={{ padding: '8px' }}>
//         ₹ {Number(proposal.DeductionAmount || 0).toLocaleString("en-IN")}
//     </td>

//     <td style={{ padding: '8px' }}>
//         {proposal.UploadedOn
//             ? new Date(proposal.UploadedOn).toLocaleString()
//             : "-"
//         }
//     </td>

//     <td style={{ padding: '8px' }}>
//         {proposal.Approvance9 === "true" ? (
//             <div
//                 className='m-auto'
//                 style={{
//                     width: '20px',
//                     height: '20px',
//                     borderRadius: '6px',
//                     backgroundColor: '#16C60C',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     color: 'white'
//                 }}
//             >
//                 ✓
//             </div>
//         ) : (
//             <div
//                 className='m-auto'
//                 style={{
//                     width: '20px',
//                     height: '20px',
//                     borderRadius: '6px',
//                     backgroundColor: '#dc2626',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     color: 'white'
//                 }}
//             >
//                 ✕
//             </div>
//         )}
//     </td>

// </tr>

//                                                             );
//                                                         })
//                                                     )}
//                                                     <tr
//                                                         style={{
//                                                             fontWeight: "600",
//                                                             backgroundColor: "#f0f0f0",
//                                                             fontSize: "13px",
//                                                         }}
//                                                     >
//                                                         <td colSpan={9} style={{ textAlign: "right", padding: "8px" }}>
//                                                             {t("Total")}
//                                                         </td>

//                                                         <td style={{ padding: "8px" }}  >
//                                                             ₹ {totalBillamt.toLocaleString("en-IN")}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}  >
//                                                             ₹ {totalpayableamt.toLocaleString("en-IN")}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}  >
//                                                             ₹ {totaldeductionamt.toLocaleString("en-IN")}
//                                                         </td>
//                                                         {/* remaining columns */}
//                                                         <td colSpan={UserRole == "State" ? 19 : 20}></td>
//                                                     </tr>
//                                                 </>
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                     <div style={{ display: 'flex', justifyContent: 'space-between', height: '4rem', alignItems: 'center' }} className='mt-3' >
//                                             <div>
//                                                 <p className="text-gray-600" style={{ fontSize: "14px" }}>
//                                                     {proposallist.length > 0
//                                                         ? `Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, filteredBills.length)} of ${filteredBills.length} entries`
//                                                         : "Showing 0 to 0 of 0 entries"}

//                                                 </p>
//                                             </div>
//                                             <div style={{ display: 'flex', alignItems: 'center' }}>
//                                                 <GooglePagination
//   currentPage={currentPage}
//   totalPages={totalPages}
//   onPageChange={setCurrentPage}
// />
//                                         </div>

//                                     </div>
//                                 </div>

//                             </div>

//                         </div>

//                     </div>

//                     {
//                         selectedProposal && (
//                             <div
//                                 onClick={() => setSelectedProposal(null)}
//                                 style={{
//                                     position: 'fixed',
//                                     top: 0, left: 0,
//                                     width: '100vw',
//                                     height: '100vh',
//                                     backgroundColor: 'rgba(0, 0, 0, 0.84)',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     zIndex: 9999
//                                 }}
//                             >
//                                 <div
//                                     onClick={(e) => e.stopPropagation()}
//                                     style={{
//                                         backgroundColor: 'white',
//                                         padding: '40px 40px',
//                                         borderRadius: '20px',
//                                         width: '50%',
//                                         maxHeight: '90vh',
//                                         overflow: "hidden",
//                                         boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//                                         position: 'relative'
//                                     }}
//                                 >

//                                     <div className="col-12">

//                                         <div className="col-12  mb-3">
//                                             <div className="row">
//                                                 <div className="col-6">
//                                                     <h5 className='fw-bold'>{t("Bill Details")}</h5>
//                                                 </div>

//                                                 <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                                                     <button
//                                                         onClick={() => setSelectedProposal(null)}
//                                                         style={{
//                                                             width: '32px',
//                                                             height: '32px',
//                                                             borderRadius: '50%',
//                                                             backgroundColor: 'red',
//                                                             border: 'none',
//                                                             display: 'flex',
//                                                             justifyContent: 'center',
//                                                             alignItems: "center",
//                                                             cursor: 'pointer',
//                                                             fontSize: '24px',
//                                                             fontWeight: 'bold',
//                                                             color: 'white',
//                                                             lineHeight: 1
//                                                         }}
//                                                     >
//                                                         ×
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="col-12" style={{ height: "59vh", overflowX: "hidden", overflowY: "scroll", scrollBehavior: "smooth" }}>
//                                             <table style={{ width: '100%', height: "100%", borderCollapse: 'collapse' }}>
//                                                 <tbody>
//                                                     {Object.entries(selectedProposal).map(([key, value], index) => (
//                                                         <>
//                                                             <tr key={key} style={{ backgroundColor: index % 2 === 0 ? '#2B75D5' : '#cce0f9', border: '1px solid #cce0f9' }}>
//                                                                 <td style={{
//                                                                     fontWeight: 'bold',
//                                                                     padding: '8px',
//                                                                     width: '40%',
//                                                                     backgroundColor: '#2B75D5',
//                                                                     color: 'white',
//                                                                     border: '1px solid #cce0f9'
//                                                                 }}>
//                                                                     {key}
//                                                                 </td>
//                                                                 <td style={{
//                                                                     padding: '8px',
//                                                                     color: "black",
//                                                                     backgroundColor: index % 2 === 0 ? '#E3EBF5' : '#D0DEF1',

//                                                                 }}>
//                                                                     {/* Handle Upload Bill Copy link */}
//                                                                     {key === 'Upload Demand Copy' && value ? (
//                                                                         <a href={`${apiurl}/BillCopyDocsImages/${value}`} target="_blank" rel="noreferrer">
//                                                                             {value}
//                                                                         </a>
//                                                                     ) : value === null || value === '' ? (
//                                                                         '-'
//                                                                     ) : (
//                                                                         value.toString()
//                                                                     )}
//                                                                 </td>

//                                                             </tr>

//                                                         </>
//                                                     ))}
//                                                 </tbody>
//                                             </table>
//                                         </div>

//                                     </div>

//                                 </div>
//                             </div>
//                         )}
//                 </div>

//                 {loading && (
//                     <div
//                         style={{
//                             position: "fixed",
//                             top: 0,
//                             left: 0,
//                             width: "100%",
//                             height: "100%",
//                             background: "rgba(255,255,255,0.4)",
//                             backdropFilter: "blur(2px)",
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                             zIndex: 9999,
//                         }}
//                     >
//                         <div className="Adminloader"></div>
//                     </div>
//                 )}
//             </div>

//         </>

//     )
// }

// export default ViewOldBills;
